import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-detail-field',
  templateUrl: './detail-field.component.html'
})
export class DetailFieldComponent {

  @Input() label?: string;
  @Input() value?: string | null | number;

}
